export const MIN_TRANSCRIPT_WORDS = 25;
const MIN_DISTINCT_WORDS = 10;

// Filler that says nothing about the visit (incl. common silence hallucinations).
const GENERIC_PHRASES = [
  /this is a (conversation|recording|visit) between (a |the )?patient and (a |the |their )?(pt|physical therapist|therapist)/gi,
  /\bthank you( (so|very) much)?\b/gi,
  /\bthanks\b/gi,
  /\b(okay|ok|bye|you)\b/gi,
];

const words = (text) =>
  text.toLowerCase().replace(/[^\p{L}\p{N}'\s]/gu, ' ').split(/\s+/).filter(Boolean);

// 'not_recorded' | 'recording_error' (audio captured, nothing usable) | 'insufficient' | null = ok.
export function checkTranscript(transcript, secondsRecorded = 0) {
  let text = transcript || '';
  GENERIC_PHRASES.forEach((re) => { text = text.replace(re, ' '); });
  const meaningful = words(text);
  if (!meaningful.length) return secondsRecorded > 0 ? 'recording_error' : 'not_recorded';
  if (meaningful.length < MIN_TRANSCRIPT_WORDS || new Set(meaningful).size < MIN_DISTINCT_WORDS) {
    return 'insufficient';
  }
  return null;
}
